import { statusOptions } from 'utils/constants';

const CANCELLED_STATUS = 'cancelled';

export const getVisibleStatusOptions = (showCancelled = false) => (
    showCancelled
        ? statusOptions
        : statusOptions.filter((status) => status.value !== CANCELLED_STATUS)
);

export const sanitizeStatusFilters = (filters = [], showCancelled = false) => (
    showCancelled
        ? filters
        : filters.filter((filter) => !(filter?.property === 'status' && filter?.value === CANCELLED_STATUS))
);

export const filterVisibleOrders = (orders = [], filters = [], showCancelled = false) => {
    if (showCancelled) {
        return orders;
    }

    // Default hiding happens client-side because the current access/orders stack rejects
    // the grouped OR-filter shape that would otherwise be needed for a frontend-only request.

    const selectedStatus = filters.find((filter) => filter?.property === 'status')?.value;

    if (selectedStatus) {
        return orders;
    }

    return orders.filter((order) => order?.status !== CANCELLED_STATUS);
};
